import { ChangeEvent, useEffect, useState } from 'react'
import { AnimatedFragment } from '../Animator/AnimatedFragment'
import { IInputProps } from './Input'
import './Inputs.scss'

interface IProps extends IInputProps {
  itemList: { text: string; value: string; disabled?: boolean }[]
}

const SelectInput = (props: IProps) => {
  const [valid, setValid] = useState(false)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (props.onValidUpdate && props.name) {
      props.onValidUpdate(props.name, valid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valid])

  useEffect(() => {
    validate(props.value)
    setValue(props.value ?? '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  const validate = (value?: string) => {
    if (props.required && !value) {
      return setValid(false)
    }

    setValid(true)
  }

  const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const val = e.currentTarget.value

    props.onChange(val)
    setValue(val)
    validate(val)
  }

  const onClick = () => {
    if (props.onClick) {
      props.onClick()
    }
  }

  return (
    <AnimatedFragment visible={props.visible === undefined ? true : props.visible}>
      <div className={[props.className, 'formArea', !props.validate || valid ? '' : 'not-valid'].join(' ')}>
        <div className="form-group">
          {!!props.label && (
            <label>
              <div className="label">{props.label || ''}</div>
            </label>
          )}
          <div className="selectArea">
            <select value={value} onChange={onChange} title={props.title} onClick={onClick}>
              {!value && <option value="" disabled></option>}
              {props.itemList.map((item) => (
                <option value={item.value} key={item.value} disabled={item.disabled}>
                  {item.text}
                </option>
              ))}
            </select>
            <i className="icon-bottom" />
          </div>
        </div>
      </div>
    </AnimatedFragment>
  )
}

export default SelectInput
